import React, { useState, useEffect } from 'react'
import { Panel, Message, Button } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import CallBookNoticeForm from '../callBookNotice/CallBookNoticeForm'
import { useParams, useHistory } from 'react-router-dom'
import {
  saveCheckNotice,
  approvedCheckNotice,
  getSuppendedNoticeFile,
} from '../../redux/actions/checkNotice'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import notification from '../../utils/notification'
import { SAVE_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import pathname from '../../constants/pathname'
import CheckNoticeForm from './CheckNoticeForm'
import CheckNoticeHistory from './CheckNoticeHistory'

export default function CheckNoticeWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  // const [searchLawData, setSearchLawData] = useState(null)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [errorMsg, setErrorMsg] = useState()
  const [clearValue, setClearValue] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [docTypeValue, setDocTypeValue] = useState(props.schema?.inputForm?.docType?.value || 0)
  const [submitApprove, setSubmitApprove] = useState()
  const history = useHistory()

  const [requestApproveReq, setRequestApproveReq] = useState()
  const [isShowConfirmRequest, setIsShowConfirmRequest] = useState(false)

  const handlerOnChangeDocType = (value) => {
    console.log('handlerOnChangeDocType ', value)
    setDocTypeValue(value)
  }

  const onSubmit = async (data) => {
    console.log('onSubmitdata', data)

    const formData = new FormData()

    data.file &&
      data.file?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })

    formData.append('Id', formSchema.id || '')
    formData.append('IsRequestApprove', false)
    formData.append('NoticeType', data.docType || 0)
    formData.append('Note', data.detail || '')

    formData.append('DeleteFileIds', data.deleteFileIds || [])

    handleSaveNotice(formData)
  }

  const onSubmitRequest = async (data) => {
    console.log('onSubmitRequestdata', data)

    const formData = new FormData()

    data.file &&
      data.file?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })

    formData.append('Id', formSchema.id || '')
    formData.append('IsRequestApprove', true)
    formData.append('NoticeType', data.docType || 0)
    formData.append('Note', data.detail || '')

    formData.append('DeleteFileIds', data.deleteFileIds || [])

    setIsShowConfirmRequest(true)
    setRequestApproveReq(formData)
  }

  const handleSaveNotice = async (request) => {
    console.log('handleSaveNotice', request)
    setIsLoading(true)
    startLoading()

    try {
      const response = await saveCheckNotice(request, projectId)
      console.log('response ', response)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 10000,
        })
        setErrorMsg(null)
        setValueNullField()
        // setSearchLawData(null)
        setIsShowConfirm(false)
        //return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        setFormSchema(response)
      } else {
        setErrorMsg({ type: 'error', description: response?.errorMessage })
      }
    } catch (error) {
      console.error(error)
      notification.open('error', {
        title: error?.response?.data?.errors?.message || SAVE_ERR_MSG,
        duration: 10000,
      })
    }

    setIsShowConfirmRequest(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleSaveNoticeApproved = async (request) => {
    console.log('handleSaveNoticeApproved', request)
    setIsLoading(true)
    startLoading()

    try {
      const response = await saveCheckNotice(request, projectId)
      console.log('response ', response)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 10000,
        })
        setErrorMsg(null)
        setValueNullField()
        // setSearchLawData(null)
        setIsShowConfirm(false)
        //return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        setFormSchema(response)
      } else {
        setErrorMsg({ type: 'error', description: response?.errorMessage })
      }
    } catch (error) {
      console.error(error)
      notification.open('error', {
        title: error?.response?.data?.errors?.message || SAVE_ERR_MSG,
        duration: 10000,
      })
    }

    setIsShowConfirmRequest(false)
    doneLoading()
    setIsLoading(false)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await getSuppendedNoticeFile(fileObj.id)
      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.name)
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      console.error(error)
      notification.open('error', {
        title: 'เกิดข้อผิดพลาด ดาวน์โหลดไฟล์ไม่สำเร็จ',
        duration: 10000,
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await getSuppendedNoticeFile(fileObj.id)
      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', fileObj.name)
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      console.error(error)
      notification.open('error', {
        title: 'เกิดข้อผิดพลาด แสดงไฟล์ไม่สำเร็จ',
        duration: 10000,
      })
    }
    doneLoading()
  }

  const onSubmitApprove = (data) => {
    console.log('onSubmitApprove ', data)
    const request = {
      id: formSchema.id,
      approveType: 1,
      comment: data.approveComment,
    }

    if (formSchema?.inputForm?.buttonText?.approveButtonName) {
      setIsShowConfirm(true)
      setSubmitApprove(request)
    } else {
      handleApproveNotice(request)
    }
  }

  const onSubmitReject = (data) => {
    console.log('onSubmitReject ', data)
    const request = {
      id: formSchema.id,
      approveType: 2,
      comment: data.approveComment,
    }

    setIsShowConfirm(true)
    setSubmitApprove(request)
  }

  const handleApproveNotice = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await approvedCheckNotice(projectId, request)
      console.log('response ', response)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 10000,
        })
        setErrorMsg(null)
        setValueNullField()
        // setSearchLawData(null)
        doneLoading()
        setIsLoading(false)

        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setErrorMsg({ type: 'error', description: response?.errorMessage })
      }
    } catch (error) {
      console.error(error)
      notification.open('error', {
        title: error?.response?.data?.errors?.message || SAVE_ERR_MSG,
        duration: 10000,
      })
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const setValueNullField = () => {
    for (const key in getValues()) {
      if (key == 'lawStatus' || key == 'limitation' || key == 'noteOfTracking' || key == 'file') {
        setValue(key, null)
      }
    }

    setClearValue(true)
    setTimeout(() => {
      setClearValue(false)
    }, 500)

    clearErrors()
  }

  //console.log('inputFormTest', formSchema.inputForm)

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        bordered
        header={`เพิ่มรายละเอียดหนังสือทวงถาม (Notice)`}
      >
        {formSchema?.inputForm && (
          <>
            <CheckNoticeForm
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              onChangeDocType={handlerOnChangeDocType}
              onDownload={onDownload}
              onPreview={onPreview}
            />

            {isLoading && !isError && <OverlayLoader />}

            {formSchema.inputForm && <hr />}

            {errorMsg && (
              <Message
                showIcon
                type={errorMsg.type}
                description={errorMsg.description}
                style={{ marginBottom: 20 }}
              />
            )}

            {formSchema.inputForm && (
              <>
                {formSchema?.inputForm?.isApproveLevel ? (
                  <>
                    {formSchema?.inputForm?.buttonText?.saveButtonName && (
                      <SaveButton
                        disabled={formSchema?.disabled}
                        onClick={handleSubmit(onSubmitApprove)}
                      >
                        {formSchema?.inputForm?.buttonText?.saveButtonName || ''}
                      </SaveButton>
                    )}

                    {formSchema?.inputForm?.buttonText?.approveButtonName && (
                      <>
                        <Button
                          disabled={formSchema?.disabled}
                          onClick={handleSubmit(onSubmitReject)}
                          appearance="primary"
                          style={{
                            marginRight: 10,
                            marginBottom: 10,
                          }}
                        >
                          {formSchema?.inputForm?.buttonText?.approveButtonName || ''}
                        </Button>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {/* ปุ่มบันทึกนักวิชาการ */}
                    {formSchema?.inputForm?.buttonText?.saveButtonName && (
                      <SaveButton disabled={formSchema?.disabled} onClick={handleSubmit(onSubmit)}>
                        {formSchema?.inputForm?.buttonText?.saveButtonName || ''}
                      </SaveButton>
                    )}
                    {/* ปุ่มบันเสนอพิจารณานักวิชาการ */}
                    {formSchema?.inputForm?.buttonText?.approveButtonName && ( //docTypeValue != 0 &&
                      <>
                        <Button
                          disabled={formSchema?.disabled}
                          onClick={handleSubmit(onSubmitRequest)}
                          appearance="primary"
                          style={{
                            marginRight: 10,
                            marginBottom: 10,
                          }}
                        >
                          {formSchema?.inputForm?.buttonText?.approveButtonName || ''}
                        </Button>
                      </>
                    )}
                  </>
                )}

                {/* {formSchema?.inputForm?.buttonText?.cancelButtonName && (
                  <>
                    <CancelButton
                      //disabled={formSchema?.inputForm?.buttonText?.disabled}
                      onClick={() => {
                        // setSearchLawData(null)
                        // onSubmitCancelSearchLegalManagement()
                        // setValueNullField()
                        // setSelectRowData(null)
                        return history.push(
                          `${pathname.proposal.overview.overviewCoworker}/${projectId}`
                        )
                      }}
                    >
                      {formSchema?.inputForm?.buttonText?.cancelButtonName || ''}
                    </CancelButton>
                  </>
                )} */}

                <ConfirmWidget
                  title={
                    'ยืนยัน' +
                    (submitApprove?.approveType == 1
                      ? 'อนุม้ติ'
                      : formSchema?.inputForm?.buttonText?.approveButtonName)
                  }
                  show={isShowConfirm}
                  detail={
                    'ยืนยัน' +
                    (submitApprove?.approveType == 1
                      ? 'อนุม้ติ'
                      : formSchema?.inputForm?.buttonText?.approveButtonName)
                  }
                  onCancle={() => setIsShowConfirm(false)}
                  onConfirm={() => {
                    setIsShowConfirm(false)
                    handleApproveNotice(submitApprove)
                  }}
                />

                <ConfirmWidget
                  title={'ยืนยัน' + formSchema?.inputForm?.buttonText?.approveButtonName}
                  show={isShowConfirmRequest}
                  detail={'ยืนยัน' + formSchema?.inputForm?.buttonText?.approveButtonName}
                  onCancle={() => setIsShowConfirmRequest(false)}
                  onConfirm={() => {
                    setIsShowConfirmRequest(false)
                    handleSaveNoticeApproved(requestApproveReq)
                  }}
                />
              </>
            )}
          </>
        )}
      </Panel>

      {formSchema?.history && (
        <CheckNoticeHistory header={formSchema.history.header} data={formSchema.history.values} />
      )}
    </>
  )
}
